import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'
import il8n from './i18n'
import 'element-ui/lib/theme-chalk/index.css'

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'

import '@/icons' // icon
import '@/permission' // permission control

import watermark from '@/utils/watermark.js'
import { checkPermission } from '@/utils/permission'

import echarts from 'echarts'
import "./assets/iconfonts/iconfont.css";

import Components from '@/plugins' // 全局组件

Vue.use(Components);

// import AMap from "./utils/AmapJs.js";

Vue.config.productionTip = false
Vue.config.devtools = true

Vue.prototype.$watermark = watermark
Vue.prototype.$checkPermission = checkPermission

Vue.prototype.$echarts = echarts

Vue.use(ElementUI, {
  i18n: (key, value) => il8n.t(key, value)
})

Vue.directive('has', {
  inserted: function (el, binding) {
    var expression = binding.value
    if (expression == undefined) {
      expression = binding.expression
    }
    if (!checkPermission(expression)) {
      el.parentNode.removeChild(el)
    }
    function checkPermission(value) {
      if (value && value.length > 0) {
        const permissionList = store.getters.permission
        return permissionList.indexOf(value) > -1
      } else {
        return false
      }
    }
  }
})

new Vue({
  el: '#app',
  router,
  i18n: il8n,
  store: store,
  render: (h) => h(App)
})
